import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const team = [{
  name: 'Dra. Valentina Ruiz',
  role: 'Directora Médica',
  icon: '👩‍⚕️',
  bio: 'Especialista en medicina interna con más de 10 años de experiencia. Su pasión es ver a los peludos recuperarse.',
  color: 'bg-primary',
  rotate: '-rotate-2'
}, {
  name: 'Dr. Martín López',
  role: 'Cirujano',
  icon: '👨‍⚕️',
  bio: 'Manos firmes y corazón gigante. Experto en cirugías de tejidos blandos y traumatología.',
  color: 'bg-secondary',
  rotate: 'rotate-2'
}, {
  name: 'Lic. Camila Torres',
  role: 'Nutrición Animal',
  icon: '👩‍🌾',
  bio: 'Porque somos lo que comemos. Cami diseña planes nutricionales para que tu mascota esté llena de energía.',
  color: 'bg-accent',
  rotate: '-rotate-1'
}];
export const Team: React.FC = () => {
  return <section id="equipo" className="py-24 bg-white border-y-3 border-text" data-id="element-148">
      <div className="container mx-auto px-4" data-id="element-149">
        <SectionHeading title="Un equipo que ama lo que hace" subtitle="Profesionales capacitados, pero sobre todo, humanos empáticos." data-id="element-150" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16 max-w-6xl mx-auto" data-id="element-151">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} whileHover={{
          scale: 1.03
        }} className={`bg-white border-3 border-text rounded-3xl p-8 neo-shadow-lg transform ${member.rotate} transition-all duration-300`} data-id="element-152">
              <div className={`${member.color} border-3 border-text rounded-full w-40 h-40 mx-auto mb-6 flex items-center justify-center text-7xl neo-shadow-sm overflow-hidden`} data-id="element-153">
                {member.icon}
              </div>
              <div className="text-center" data-id="element-154">
                <h3 className="text-2xl font-black mb-1" data-id="element-155">{member.name}</h3>
                <p className="text-primary font-bold text-lg mb-4 uppercase tracking-wide drop-shadow-sm" data-id="element-156">
                  {member.role}
                </p>
                <p className="font-medium text-gray-800 text-lg" data-id="element-157">
                  {member.bio}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};